<template>
  <div class="supplier-edit">
    <v-form ref="formProcess" v-model="valid" lazy-validation>

      <v-container>

        <v-row>
          <v-col>
            <h4>設備・外観</h4>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="img in imageList1" :key="img.fileId" cols="12" md="4">
            <file-card :file-id="img.fileId" :can-delete="true" v-on:delete="onImageDelete(img)" />
            <p>写真へのコメント {{img.fileId}} {{img.remarks}}
            <v-btn icon v-on:click="onFileComment(img)"><v-icon>mdi-pencil-box</v-icon></v-btn>
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn @click="onAppendFileClick('1')">追加</v-btn>
          </v-col>
        </v-row>

        <hr class="my-3">

        <v-row>
          <v-col>
            <h4>製品・カタログ</h4>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="img in imageList2" :key="img.fileId" cols="12" md="4">
            <file-card :file-id="img.fileId" :can-delete="true" />
            <p>写真へのコメント {{img.fileId}} {{img.remarks}}
              <v-btn icon v-on:click="onFileComment(img)"><v-icon>mdi-pencil-box</v-icon></v-btn>
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn @click="onAppendFileClick('2')">追加</v-btn>
          </v-col>
        </v-row>


        <hr class="my-3">
        <v-row>
          <v-col>
            <h4>建屋・人物</h4>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="img in imageList3" :key="img.fileId" cols="12" md="4">
            <file-card :file-id="img.fileId" :can-delete="true" />
            <p>写真へのコメント {{img.fileId}} {{img.remarks}}
              <v-btn icon v-on:click="onFileComment(img)"><v-icon>mdi-pencil-box</v-icon></v-btn>
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn @click="onAppendFileClick('3')">追加</v-btn>
          </v-col>
        </v-row>

      </v-container>

    </v-form>

    <file-upload-dialog ref="fileUploadDialog"></file-upload-dialog>

    <v-dialog
        v-model="isShowUploadDialog"
        width="500"
    >

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Privacy Policy
        </v-card-title>

        <v-card-text>

          <template>
            <v-file-input
                multiple
                label="File input"
            ></v-file-input>
          </template>


          <v-container class="file-drop-area" ref="uploadTarget" v-on:dragover="onDragOver" v-on:dragenter="onDragEnter" v-on:dragleave="onDragLeave" v-on:drop="onDrop">

            <v-row>
              <v-col>
                画像ファイルをドロップしてください
              </v-col>
            </v-row>

          </v-container>


        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="isShowUploadDialog = false"
          >
            I accept
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

    <v-dialog v-model="isShowImageCommentDialog"
      persistent
      max-width="600px">
      <v-card>
        <v-card-title>
          <span>コメント</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="imageComment" outlined></v-text-field>
        </v-card-text>        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isShowImageCommentDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" text @click="onFileCommentSave">
            OK
          </v-btn>
        </v-card-actions>  
      </v-card>      
    </v-dialog>

  </div>
</template>
<script>
import BaseView from "../../components/BaseView";
import FileAssetAPI from "@/apis/FileAssetAPI";
import FileUploadDialog from "@/components/dialogs/FileUploadDialog";
export default {
    mixins:[BaseView],
    components: {
      FileUploadDialog
    },
    props:{
      cat1: {
        type: Array,
        required: true
      },
      cat2: {
        type: Array,
        required: true
      },
      cat3: {
        type: Array,
        required: true
      },
    },
    data: () => ({
        isInitialized:false,
        isFetched:false,
        isLoading:false,
        isDownloading:false,


        isShowUploadDialog:false,

        isShowImageCommentDialog:false,

        imageComment:"",

        condition:{},
        pager:{},
        errors:{},
        valid:true,
    }),
    computed: {
      imageList1: {
        get: function() {
          return this.cat1
        },
        set: function (v) {
          this.$emit("cng-cat1", v)
        }
      },
      imageList2: {
        get: function() {
          return this.cat2
        },
        set: function (v) {
          this.$emit("cng-cat2", v)
        }
      },
      imageList3: {
        get: function() {
          return this.cat3
        },
        set: function (v) {
          this.$emit("cng-cat3", v)
        }
      },
    },
    mounted:function() {
        this.setupConditions();
    },
    created:function() {
    },
    watch: {
        '$route':function (to, from) {
            this.setupConditions();
        },
    },
    methods: {
        setupConditions(){

        },

        fetchData(needDataFetch){
            let self = this;
            if (!this.isInitialized){
                this.fetchBasicData(function () {
                    self.fetchData(needDataFetch)
                });
                return;
            }
            if (needDataFetch){
                this.isLoading = true;
                Promise.resolve()
                    .then(data => {
                        //
                    })
                    .catch(function(err) {
                        console.log(err);
                        self.showErrorToast("データの取得に失敗しました。");
                    });
            }
        },

        fetchBasicData(finishProc){
            this.isInitialized = true;
            if (finishProc){
                finishProc();
            }
        },

      async onAppendFileClick(cat){

        let files = await this.$refs.fileUploadDialog.open("アップロード","",{})

        if (files){

          let list
          if (cat == '1'){
            list = this.imageList1
          }
          else if (cat == '2'){
            list = this.imageList2
          }
          else if (cat == '3'){
            list = this.imageList3
          } else {
            throw "対応していないカテゴリーです " + cat
          }

          files.forEach(f => {
            list.push({ fileId:f, category:cat, remarks:"" })
          })

          if (cat == '1'){
            this.imageList1 = list
          }
          else if (cat == '2'){
            this.imageList2 = list
          }
          else if (cat == '3'){
            this.imageList3 = list
          }

        }

      },


      // --------------------------------------
      // ファイルのドロップ処理
      // --------------------------------------
      findTargetElement(){
        return this.$refs.uploadTarget;
      },

      onDrop(e){
        e.preventDefault();
        e.stopPropagation();

        let elm = this.findTargetElement();
        elm.classList.remove('filehover');


        //console.log("onDrop ");

        let files = e.dataTransfer.files;
        //console.log(files);
        //this.processFiles(files);

        this.uploadFiles(files);
      },

      onDragOver(e){
        e.preventDefault();
        let elm = this.findTargetElement();
        elm.classList.add('filehover');
      },

      onDragEnter(e){
        e.preventDefault();
      },

      onDragLeave(e){
        e.preventDefault();
        let elm = this.findTargetElement();
        elm.classList.remove('filehover');
      },

      uploadFiles(files){


        let self = this;

        let targetFiles = [];

        if (files){
          if (files instanceof FileList){
            for (let i=0; i<files.length; i++) {
              let file = files[i];
              targetFiles.push(file);
            }
          } else {
            targetFiles.push(files);
          }
        } else return;

        targetFiles = targetFiles.filter(file => {
          return file.type === "image/png" || file.type === "image/jpeg";
        });

        let progressFunc = function(progress){
          console.log("uploadFile progress:" + progress);
        };

        if (targetFiles.length > 0){

          window.logger.log(targetFiles)

          let file = targetFiles[0];

          FileAssetAPI.provisionalUpload(file,{},progressFunc)
              .then(a => {

                let fileId = a.fileId;
                window.logger.info("fileId = " + fileId)

                self.editData.cat1.push(fileId)

                self.isShowUploadDialog = false;

              })
              .catch(function(err) {
                console.log(err);
                self.showErrorToast("データの更新に失敗しました。");
              });


        }


      },


      onFileComment(img){
        
        this.editingImage = img;

        this.imageComment = img.remarks ?? "";
        this.isShowImageCommentDialog = true;        
      },

      onFileCommentSave(){
        this.editingImage.remarks = this.imageComment;
        this.isShowImageCommentDialog = false;
      },

      onImageDelete(img){
        this.$emit("delete", img)        
      },

    },

}
</script>